export enum ECoin {
  ETHEREUM = 1,
  USD = 2,
  USDT = 3,
  DEMO = 4,
  MAIN = 3, //Main coin
  CIC = 6,
  VLT = 8,
  STAKING = 9,
  TEST = 100,
  MUT = 10,
  VIET = 11,
  MEME = 12,
  BONK = 13,
  DOGE = 14,
  PEPE = 15,
  SHIB = 16,
  C98 = 17,
  USDX = 18,
  USDT_PROFIT = 19,
  GAS = 20,
  USDX_PROFIT = 21,
}
